import React from 'react';
import './ConsultationDossier.css';


const ConsultationDossier= () => {
    return ( 
        <div className='merecd'>

        <div className='containerAcd'>
            
            <div className='barrescd'>
            <div className='trait1cd'></div>
            <div className='trait2cd'></div>
            </div>
            <div className='titrecd'>
                <h1>CONSULTATION DOSSIERS </h1>
            </div>
            <div className='ligne5cd'>
            </div>
            </div>
            <div className='textecd'>
              
            <p> Pour suivre l'état d'avancement de votre demande ou consulter les autorisations déjà délivrées, un portail en ligne est mis à votre disposition (si disponible), ou vous pouvez vous rendre directement au service d'urbanisme de la mairie.</p>
            
           </div>
           
    </div>
    
    );
};

export default ConsultationDossier;
